<template>
  <layout>
    <div slot="content">
      <i-card :title="this.$route.meta.title">
        <div slot="content">
          <div class="order-filter-wrap">
            <el-form size="small" label-width="92px" class="order-filter-form">
              <el-row :gutter="16">
                <el-col :span="6">
                  <el-form-item label="订单号">
                    <el-input placeholder="订单号" v-model="filter.uuid" clearable class="order-filter-control"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="商品名称">
                    <el-select placeholder="商品名称" v-model="filter.product_id" clearable class="order-filter-control">
                      <el-option v-for="product in productList" :label="product.title" :value="product.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="filter.goods_type === 11 ? '航班号' : '联系人手机'">
                    <el-input
                      v-if="filter.goods_type === 11"
                      placeholder="航班号"
                      v-model="filter.sailings_code"
                      clearable
                      class="order-filter-control">
                    </el-input>
                    <el-input
                      v-else
                      v-model="filter.linker_mobile"
                      placeholder="联系人手机"
                      clearable
                      class="order-filter-control">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="filter.goods_type === 11 ? '联系人手机' : '联系人姓名'">
                    <el-input
                      v-if="filter.goods_type === 11"
                      v-model="filter.linker_mobile"
                      placeholder="联系人手机"
                      clearable
                      class="order-filter-control">
                    </el-input>
                    <el-input
                      v-else
                      v-model="filter.linker_name"
                      placeholder="联系人姓名"
                      clearable
                      class="order-filter-control">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="6">
                  <el-form-item :label="filter.goods_type === 11 ? '联系人姓名' : '出行日期'">
                    <el-input
                      v-if="filter.goods_type === 11"
                      v-model="filter.linker_name"
                      placeholder="联系人姓名"
                      clearable
                      class="order-filter-control">
                    </el-input>
                    <el-date-picker
                      v-else
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      v-model="filter.use_date"
                      value-format="yyyy-MM-dd"
                      placeholder="出行日期"
                      clearable
                      class="order-filter-control">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="filter.goods_type === 11 ? '出行日期' : '支付状态'">
                    <el-date-picker
                      v-if="filter.goods_type === 11"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      v-model="filter.use_date"
                      value-format="yyyy-MM-dd"
                      placeholder="出行日期"
                      clearable
                      class="order-filter-control">
                    </el-date-picker>
                    <el-select
                      v-else
                      placeholder="支付状态"
                      v-model="filter.pay_status"
                      clearable
                      class="order-filter-control">
                      <el-option label="未支付" value="0"></el-option>
                      <el-option label="已支付" value="1"></el-option>
                      <el-option label="退款中" value="2"></el-option>
                      <el-option label="已退款" value="3"></el-option>
                      <el-option label="拒绝退款" value="4"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="filter.goods_type === 11 ? '支付状态' : '处理状态'">
                    <el-select
                      v-if="filter.goods_type === 11"
                      placeholder="支付状态"
                      v-model="filter.pay_status"
                      clearable
                      class="order-filter-control">
                      <el-option label="未支付" value="0"></el-option>
                      <el-option label="已支付" value="1"></el-option>
                      <el-option label="退款中" value="2"></el-option>
                      <el-option label="已退款" value="3"></el-option>
                      <el-option label="拒绝退款" value="4"></el-option>
                    </el-select>
                    <el-select
                      v-else
                      placeholder="处理状态"
                      v-model="filter.resolve_status"
                      clearable
                      class="order-filter-control">
                      <el-option label="已沟通" value="2"></el-option>
                      <el-option label="已处理" value="1"></el-option>
                      <el-option label="未处理" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="filter.goods_type === 11 ? '处理状态' : '订单平台'">
                    <el-select
                      v-if="filter.goods_type === 11"
                      placeholder="处理状态"
                      v-model="filter.resolve_status"
                      clearable
                      class="order-filter-control">
                      <el-option label="已沟通" value="2"></el-option>
                      <el-option label="已处理" value="1"></el-option>
                      <el-option label="未处理" value="0"></el-option>
                    </el-select>
                    <el-select
                      v-else
                      placeholder="订单平台"
                      v-model="filter.platform"
                      clearable
                      class="order-filter-control">
                      <el-option label="微信" value="1"></el-option>
                      <el-option label="支付宝" value="4"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="6">
                  <el-form-item :label="filter.goods_type === 11 ? '订单平台' : '订单来源'">
                    <el-select
                      v-if="filter.goods_type === 11"
                      placeholder="订单平台"
                      v-model="filter.platform"
                      clearable
                      class="order-filter-control">
                      <el-option label="微信" value="1"></el-option>
                      <el-option label="支付宝" value="4"></el-option>
                    </el-select>
                    <el-select
                      v-else
                      filterable
                      placeholder="订单来源"
                      v-model="filter.app_id"
                      clearable
                      class="order-filter-control">
                      <el-option v-for="app in appOptions" :label="app.label+ '('+ app.platform_name +')'" :value="app.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="filter.goods_type === 11 ? '订单来源' : '意向退款'">
                    <el-select
                      v-if="filter.goods_type === 11"
                      filterable
                      placeholder="订单来源"
                      v-model="filter.app_id"
                      clearable
                      class="order-filter-control">
                      <el-option v-for="app in appOptions" :label="app.label+ '('+ app.platform_name +')'" :value="app.value" />
                    </el-select>
                    <el-select
                      v-else
                      placeholder="意向退款"
                      v-model="filter.intention_refund"
                      clearable
                      class="order-filter-control">
                      <el-option label="有" value="1"></el-option>
                      <el-option label="无" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if="filter.goods_type === 11">
                  <el-form-item label="意向退款">
                    <el-select placeholder="意向退款" v-model="filter.intention_refund" clearable class="order-filter-control">
                      <el-option label="有" value="1"></el-option>
                      <el-option label="无" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="订单简码">
                    <el-input v-model="filter.short_code" placeholder="如 03001" clearable class="order-filter-control"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="下单日期">
                    <el-date-picker
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始"
                      end-placeholder="结束"
                      v-model="filter.order_created_at"
                      value-format="yyyy-MM-dd"
                      placeholder="按创建时间"
                      clearable
                      class="order-filter-control"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" style="text-align: right;">
                  <el-button type="primary" @click="getOrder(1)">查找</el-button>
                  <el-button type="primary" @click="exportData()">导出</el-button>
                  <el-button type="primary" @click="reset">重置</el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div>出行人数：{{peopleCount}} 人</div>
          <div style="overflow-x: auto;padding-bottom: 20px;" v-loading="loading">
            <div class="no-data" v-if="orderList.length <= 0">暂无订单</div>
            <div class="table-card" v-for="item in orderList">
              <div class="order-info" :style="item.people.length > 0?'border-bottom:0':''">
                <div class="order-item" style="width: 100%">
                  商品名称:{{ item.title }}(<strong>{{ item.goods_type }}</strong>)
                  <span v-if="item.short_code" class="order-short-code"> 简码 {{ item.short_code }}</span>
                </div>
                <div class="order-item intention-refund-row" style="width: 100%" v-if="item.intention_refund_info">
                  <el-tooltip effect="dark" placement="top">
                    <div slot="content">
                      提交时间：{{ item.intention_refund_info.submit_at || '-' }}<br/>
                      原因：{{ item.intention_refund_info.reason || '-' }}<br/>
                      备注：{{ item.intention_refund_info.remark || '-' }}
                    </div>
                    <div class="refund-audit-banner">
                      <span class="refund-audit-title">退款审核中</span>
                      <span class="refund-audit-time">{{ getIntentionRefundCountdown(item.intention_refund_info) }}</span>
                    </div>
                  </el-tooltip>
                  <el-button size="mini" type="warning" plain @click="confirmCancelIntentionRefund(item)">取消退款申请</el-button>
                </div>
                <div class="order-item">
                  订单来源:{{ item.app_name }}--{{ item.app_platform_name }}
                </div>
                <div class="order-item">
                  平台来源:
                  <strong :style="{color: item.app_platform_name === '微信' ? '#07c160' : '#1677ff'}">
                    <i :class="item.app_platform_name === '微信' ? 'el-icon-postcard' : 'el-icon-wallet'" style="margin-right: 3px;"></i>
                    {{ item.app_platform_name || '未知' }}
                  </strong>
                </div>
                <div class="order-item">
                  航班号:{{ item.ship ? item.ship.sailings_code : '该订单无航班' }}
                </div>
                <div class="order-item">
                  联系人:{{ item.linker_name }}
                </div>
                <div class="order-item">
                  联系人手机:{{ item.linker_mobile }}
                </div>
                <div class="order-item">
                  出行日期:{{ item.use_date }}
                </div>
                <div class="order-item">
                  订单号:{{ item.uuid }}
                </div>
                <div class="order-item">
                  下单时间:{{ item.created_at }}
                </div>
                <div class="order-item">
                  购买数量:{{ item.goods_count }}张
                </div>
                <div class="order-item">
                  登船口:{{ item.ship ? (item.ship.enter_no || '未填写') : '该订单无航班' }}
                </div>
                <div class="order-item">
                  票券:{{ item.sku_title }}
                </div>
                <div class="order-item">
                  订单金额:{{ item.total }}元
                </div>
                <div class="order-item">
                  支付金额:{{ item.pay_total }}元
                </div>
                <div class="order-item">
                  订单类型:
                  <el-tag size="mini" type="warning">
                    {{ item.distribution.length > 0 ? '分销订单' : '普通订单' }}
                  </el-tag>
                </div>
                <div class="order-item">
                  支付状态:
                  <el-tag size="mini" :type="item.pay_status === 1?'success':'danger'">
                    {{ item.pay_status_name }}
                  </el-tag>
                </div>
                <div class="order-item">
                  出票状态:
                  <el-tag size="mini" :type="item.check_status === 2?'success':'danger'">
                    {{ item.check_status_name }}
                  </el-tag>
                </div>
                <div class="order-item">
                  处理状态:
                  <el-tag size="mini" :type="item.resolve_status === 1 ? 'success' : (item.resolve_status === 2 ? 'warning' : 'danger')">
                    {{ item.resolve_status_name }}
                  </el-tag>
                </div>
                <div class="order-item">
                  支付商户:{{ item.mch_name }}({{ item.mch_id }})
                </div>
                <div class="order-item">
                  集合地点:
                  <template v-if="(item.meeting_info && item.meeting_info.name) || item.meeting_point">
                    <el-popover
                      placement="top"
                      trigger="hover"
                      :width="hasMeetingDetail(item) ? 320 : 0"
                      :disabled="!hasMeetingDetail(item)"
                    >
                      <div class="mp-detail" v-if="hasMeetingDetail(item)">
                        <div class="mp-detail-row" v-if="item.meeting_info && item.meeting_info.address">
                          <strong>地址：</strong>{{ item.meeting_info.address }}
                        </div>
                        <div class="mp-detail-row" v-if="item.meeting_info && (item.meeting_info.longitude || item.meeting_info.latitude)">
                          <strong>坐标：</strong>{{ item.meeting_info.longitude }} , {{ item.meeting_info.latitude }}
                        </div>
                        <div class="mp-detail-images" v-if="item.meeting_info && item.meeting_info.image_urls && item.meeting_info.image_urls.length">
                          <el-image
                            v-for="(url, i) in item.meeting_info.image_urls"
                            :key="i"
                            :src="url"
                            :preview-src-list="item.meeting_info.image_urls"
                            fit="cover"
                            class="mp-detail-thumb"
                          />
                        </div>
                      </div>
                      <el-tag slot="reference" size="mini" type="warning" style="cursor:pointer;">
                        {{ (item.meeting_info && item.meeting_info.name) || item.meeting_point }}
                      </el-tag>
                    </el-popover>
                  </template>
                  <span v-else style="color:#bbb">未确定</span>
                </div>
                <div class="order-item">
                  集合时间:
                  <el-tag v-if="(item.meeting_info && item.meeting_info.time) || item.meeting_time" size="mini" type="warning">
                    {{ (item.meeting_info && item.meeting_info.time) || item.meeting_time }}
                  </el-tag>
                  <span v-else style="color:#bbb">未确定</span>
                </div>
                <div class="order-item" style="width:100%;text-align: right;padding: 10px;">
                  <el-button size="mini" type="primary" @click="doShowDetails(item.uuid)">详情/编辑</el-button>
                  <el-button
                    size="mini"
                    plain
                    :disabled="!item.contract_template_id"
                    @click="openContractPreview(item)">查看合同</el-button>
                  <el-button
                    size="mini"
                    plain
                    type="warning"
                    :disabled="!item.contract_template_id || item.pay_status !== 1"
                    :loading="item._regeneratingContract"
                    @click="regenerateContract(item)">重新生成合同</el-button>
                  <el-button size="mini" type="success" @click="copyOrderBaseInfo(item)">复制订单信息</el-button>
                  <el-button size="mini" type="success" @click="copyPeople(item.people,item)">复制游客信息</el-button>
                  <el-button size="mini" type="success" @click="showResolveConfirm(item)" :disabled="item.resolve_status !== 0">标记沟通</el-button>
                  <el-button
                    v-if="item.resolve_status === 1 || item.resolve_status === 2"
                    size="mini"
                    type="warning"
                    @click="showEditMeetingInfo(item)">修改集合点</el-button>
                  <el-button size="mini" type="success" @click="showRefund(item.uuid)">申请退款</el-button>
                  <el-button size="mini" type="success" @click="showCheckConfirm(item.uuid)">出票</el-button>
                </div>
              </div>
              <table class="table">
                <tr v-for="people in item.people">
                  <td width="20%">{{ people.name }}</td>
                  <td width="20%">{{ maskIdCard(people.cert_no,people.cert_type) }}</td>
                  <td width="10%">{{ people.cert_type }}</td>
                  <td width="10%">{{people.price }} <template v-if="people.age_discount_rule.title">({{ people.age_discount_rule.title }})</template></td>
                  <td width="10%">{{ people.mobile }}</td>
                  <td width="10%">{{ people.age }}</td>
<!--                  <td width="20%">-->
<!--                    <el-radio @input="chooseSupplier(people.id,'')" v-model="people.supplier" label="">无</el-radio>-->
<!--                    <el-radio @input="chooseSupplier(people.id,'XA')" v-model="people.supplier" label="XA">XA</el-radio>-->
<!--                    <el-radio @input="chooseSupplier(people.id,'XF')" v-model="people.supplier" label="XF">XF</el-radio>-->
<!--                  </td>-->
                  <td width="20%">备注:
                    <el-input style="width: 80%" v-model="people.remark" size="mini" placeholder="请输入备注"
                              @blur="addRemark(people.id,people.remark)"></el-input>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="page-wrap">
            <el-pagination background :page-size="15" :current-page="pageInfo.current_page" layout="prev, pager, next"
                           @current-change="changePage" :total="pageInfo.total"/>
          </div>
        </div>
      </i-card>
      <!--订单详情-->
      <el-drawer size="800" @close="closeOrder" :withHeader="false" :modal-append-to-body="true" :append-to-body="true"
                 custom-class="scroll" :visible.sync="showDetails">
        <orderDetails :uuid="currUuid"/>
      </el-drawer>
      <!--标记沟通 / 修改集合点-->
      <el-dialog
        :title="resolveDialogMode === 'edit' ? '修改集合点' : '标记已沟通'"
        :visible.sync="resolveOrderDialog"
        width="480px">
        <div style="margin-bottom: 12px;color:#666;font-size:13px;">
          <template v-if="resolveDialogMode === 'edit'">调整订单的集合地点 / 时间，不影响订单当前状态；客户端订单详情会同步更新。</template>
          <template v-else>确认已与客户沟通确认出行信息，可选填集合地点和时间。集合地点信息将完整保存到订单中，客户端会同步展示。</template>
        </div>
        <div class="resolve-order-summary">
          <div class="resolve-order-summary__item">订单简码：{{ currSolveOrder.short_code || '无' }}</div>
          <div class="resolve-order-summary__item">联系人：{{ currSolveOrder.linker_name || '无' }}</div>
          <div class="resolve-order-summary__item">联系电话：{{ currSolveOrder.linker_mobile || '无' }}</div>
          <div class="resolve-order-summary__item">出行日期：{{ currSolveOrder.use_date || '无' }}</div>
        </div>
        <el-form label-width="80px" size="small">
          <el-form-item label="集合地点">
            <el-select
              v-model="currSolveOrder.meeting_point_id"
              placeholder="请选择集合地点（可选）"
              clearable
              filterable
              style="width: 100%"
              @change="onSelectMeetingPoint">
              <el-option
                v-for="mp in meetingPointOptions"
                :key="mp.id"
                :label="mp.name"
                :value="mp.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="集合时间">
            <el-select
              v-model="currSolveOrder.meeting_time"
              placeholder="请选择集合时间（可选，00/15/20/30/50分）"
              clearable
              filterable
              style="width: 100%">
              <el-option
                v-for="t in meetingTimeOptions"
                :key="t"
                :label="t"
                :value="t"/>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resolveOrderDialog = false">取 消</el-button>
          <el-button type="primary" @click="resolveOrder" :loading="resolveLoading">确 定</el-button>
        </div>
      </el-dialog>
      <!--申请退款-->
      <el-dialog title="申请退款" :visible.sync="refund.showDialog" width="40%">
        <el-form ref="form" label-width="80px">
          <el-form-item required label="退款原因">
            <el-input v-model="refund.reason" placeholder="请输入退款原因"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="refund.showDialog = false">取 消</el-button>
          <el-button type="primary" @click="doRefund" :loading="refund.refundLoading">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
import orderDetails from "@/pages/order/order-detail-left"
import {id} from "html-webpack-plugin/lib/chunksorter";
import OrderReminderService from '@/services/orderReminderService'

export default {
  components: {
    orderDetails
  },
  name: "order-list",
  computed: {
    meetingTimeOptions: function () {
      const list = [];
      for (let h = 0; h < 24; h++) {
        const hh = h.toString().padStart(2, '0');
        ['00', '15', '20', '30', '50'].forEach(mm => list.push(hh + ':' + mm));
      }
      return list;
    }
  },
  data() {
    return {
      orderList: [],
      showDetails: false,
      currUuid: "",
      filter: {
        linker_mobile: '',
        pay_status: '',
        uuid: '',
        short_code: '',
        use_date: '',
        order_created_at: null,
        goods_type: '',
        resolve_status: '',
        title: '',
        sailings_code: '',
        platform: '',
        app_id: '',
        product_id: '',
        intention_refund: '',
      },
      loading: false,
      pageInfo: {
        current_page: 1,
        total: 0,
      },
      appOptions: [],
      resolveOrderDialog: false,
      resolveLoading: false,
      resolveDialogMode: 'mark', // 'mark' 标记沟通; 'edit' 修改集合点
      meetingPointOptions: [],
      currSolveOrder: {
        uuid: "",
        meeting_point_id: '',
        meeting_point: '',
        meeting_time: '',
        short_code: '',
        linker_name: '',
        linker_mobile: '',
        use_date: '',
      },
      refund: {
        showDialog: false,
        reason: "",
        orderUuid: "",
        refundLoading: false
      },
      balance:0,
      productList:[],
      peopleCount: 0,
      nowTs: Date.now(),
      countdownTimer: null,
    }
  },
  methods: {
    getOrder: function (page = '', needScroll = true, isExport = false) {
      if (needScroll) {
        this.loading = true;
      }
      if (page) {
        this.pageInfo.current_page = page;
      }
      this.$http.request('orderList', {
        filter: this.filter,
        page: this.pageInfo.current_page
      }).then(res => {
        this.orderList = res.data;
        this.loading = false;
        this.pageInfo = res.meta;
        if (needScroll) {
          window.scrollTo(0, 0)
        }
      });
      this.getPeopleCount();
    },
    getBalance:function (){
      this.$http.request("opWalletBalance").then(res => {
        this.balance = res.data.balance;
      });
    },

    exportData: function () {
      this.$http.request('exportOrderCount', {
        filter: this.filter,
      }).then(res => {
        const orderCount = res.data.order_count || 0;
        const exportLimit = res.data.export_limit || 10000;
        if (orderCount > exportLimit) {
          this.$alert(
            `本次导出范围超出${exportLimit}条（当前${orderCount}条），请缩小查找范围`,
            '无法导出',
            { type: 'warning' }
          );
          return;
        }
        this.$confirm(
          `本次导出范围内共 ${orderCount} 条订单，是否确认导出？`,
          '导出确认',
          { type: 'warning' }
        ).then(() => {
          const url = this.$http.request('exportOrder', {
            filter: this.filter,
            hash: Math.random() * 1000,
          }, true);
          window.open(url);
        }).catch(() => {});
      });
    },
    getPeopleCount: function () {
      this.$http.request('getPeopleCount', {
        filter: this.filter,
      }).then(res=>{
        this.peopleCount = res.data.people_count;
      });
    },
    getAppOptions: function () {
      this.$http.request('appListOptions').then(res => {
        this.appOptions = res.data;
      })
    },
    closeOrder: function () {
      this.$http.request('orderList', {
        filter: this.filter,
        page: this.pageInfo.current_page
      }).then(res => {
        this.orderList = res.data;
        this.pageInfo = res.meta;
      });
    },
    changePage: function (page) {
      this.pageInfo.current_page = page;
      this.getOrder();
    },
    reset: function () {
      for (let i in this.filter) {
        if (i !== 'goods_type') {
          this.filter[i] = i === 'order_created_at' ? null : '';
        }
      }
      this.getOrder();
    },
    showCheckConfirm: function (uuid) {
      this.$confirm('确定要出票吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.checkOut(uuid);
      });
    },
    showResolveConfirm: function (item) {
      this.resolveDialogMode = 'mark';
      this.resolveOrderDialog = true;
      this.currSolveOrder = {
        uuid: item.uuid,
        meeting_point_id: '',
        meeting_point: '',
        meeting_time: '',
        short_code: item.short_code || '',
        linker_name: item.linker_name || '',
        linker_mobile: item.linker_mobile || '',
        use_date: item.use_date || '',
      };
    },
    showEditMeetingInfo: function (order) {
      this.resolveDialogMode = 'edit';
      this.resolveOrderDialog = true;
      // 优先取 meeting_info 里的快照信息，回显已有的集合点/时间
      const mi = order.meeting_info || {};
      this.currSolveOrder = {
        uuid: order.uuid,
        meeting_point_id: mi.id || '',
        meeting_point: mi.name || order.meeting_point || '',
        meeting_time: mi.time || order.meeting_time || '',
        short_code: order.short_code || '',
        linker_name: order.linker_name || '',
        linker_mobile: order.linker_mobile || '',
        use_date: order.use_date || '',
      };
    },
    onSelectMeetingPoint: function (id) {
      const hit = this.meetingPointOptions.find(mp => mp.id === id);
      this.currSolveOrder.meeting_point = hit ? hit.name : '';
    },
    hasMeetingDetail: function (item) {
      const mi = item && item.meeting_info;
      if (!mi) return false;
      const hasAddr = !!mi.address;
      const hasCoord = !!(mi.longitude || mi.latitude);
      const hasImages = !!(mi.image_urls && mi.image_urls.length);
      return hasAddr || hasCoord || hasImages;
    },
    openContractPreview: function (item) {
      if (!item || !item.uuid) return;
      const route = this.$router.resolve({
        name: 'contract.preview',
        query: { orderUuid: item.uuid }
      });
      window.open(route.href, '_blank');
    },
    regenerateContract: function (item) {
      if (!item || !item.uuid) return;
      const tip = item.has_contract_snapshot
        ? '重新生成将覆盖当前已保存的合同现场，是否继续？'
        : '将根据当前订单数据生成合同现场，是否继续？';
      this.$confirm(tip, '重新生成合同', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$set(item, '_regeneratingContract', true);
        return this.$http.request('regenerateContract', { order_uuid: item.uuid });
      }).then(res => {
        this.$set(item, '_regeneratingContract', false);
        if (res && res.status === 'success') {
          this.$message.success(res.message || '合同已重新生成');
          if (res.data) {
            this.$set(item, 'has_contract_snapshot', true);
            if (res.data.contract_saved_at) {
              this.$set(item, 'contract_saved_at', res.data.contract_saved_at);
            }
          }
        }
      }).catch(() => {
        this.$set(item, '_regeneratingContract', false);
      });
    },
    getMeetingPointOptions: function () {
      this.$http.request('meetingPointOptions').then(res => {
        this.meetingPointOptions = (res && res.data) || [];
      });
    },
    resolveOrder: function () {
      this.resolveLoading = true;
      const isEdit = this.resolveDialogMode === 'edit';
      const apiName = isEdit ? 'updateMeetingInfo' : 'resolveOrder';
      const payload = {
        uuid: this.currSolveOrder.uuid,
        meeting_point_id: this.currSolveOrder.meeting_point_id || 0,
        meeting_point: this.currSolveOrder.meeting_point || '',
        meeting_time: this.currSolveOrder.meeting_time || '',
      };
      this.$http.request(apiName, payload).then(res => {
        this.resolveLoading = false;
        if (res.status === 'success') {
          this.resolveOrderDialog = false;
          this.getOrder('', false);
        }
      }).catch(() => {
        this.resolveLoading = false;
      })
    },
    showRefund: function (uuid) {
      this.refund.showDialog = true;
      this.refund.orderUuid = uuid;
      this.refund.reason = "";
    },
    //退款
    doRefund: function () {
      this.refund.refundLoading = true;
      this.$http.request('createRefund', {order_uuid: this.refund.orderUuid, reason: this.refund.reason}).then(res => {
        this.refund.refundLoading = false;
        if (res.status === 'success') {
          this.refund.showDialog = false;
          this.getOrder('', false);
          this.$message({message: res.message, type: "success"});
        }
      }).catch(res => {
        this.refund.refundLoading = false;
      })
    },
    checkOut: function (uuid) {
      this.$http.request('checkOrder', {uuid: uuid}).then(res => {
        if (res.status === 'success') {
          this.getOrder('', false);
        }
      });
    },
    addRemark: function (id, remark) {
      this.$http.request('addPeopleRemark', {id: id, remark: remark}).then(res => {
        this.$notify({
          title: '成功',
          message: res.message,
          type: res.status,
          duration: 2000
        });
      });
    },
    /** 剪贴板模板公共头：订单简码（全角冒号）、出行日期、集合地点、集合时间 */
    _buildCopyClipboardHeader: function (order) {
      const mpName = (order.meeting_info && order.meeting_info.name) || order.meeting_point || "";
      const mpTime = (order.meeting_info && order.meeting_info.time) || order.meeting_time || "";
      let h = "";
      if (order.short_code) {
        h += "订单简码：" + order.short_code + "\n";
      }
      h += "出行日期:" + (order.use_date || "") + "\n";
      if (mpName) {
        h += "集合地点:" + mpName + "\n";
      }
      if (mpTime) {
        h += "集合时间:" + mpTime + "\n";
      }
      return h;
    },
    copyOrderBaseInfo: function (order) {
      let content = this._buildCopyClipboardHeader(order);
      content += "\n联系人:" + (order.linker_name || "") + "\n";
      content += "联系人手机:" + (order.linker_mobile || "") + "\n";
      if (order.ship) {
        content += "航班号:" + order.ship.sailings_code + "\n";
        content += "开船时间:" + order.ship.start_time + "\n";
        content += "人数:" + order.goods_count + "\n";
        content += order.ship.start_wharf + '-' + order.ship.end_wharf + "\n";
      }

      let aux = document.createElement("textarea");
      aux.value = content;
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      this.$message({message: "复制成功!", type: "success"});
      this.$http.request('copyPeopleLog',{order_uuid:order.uuid,copy_content:content});
    },
    copyPeople: function (people, order) {
      this.getBalance();
      if(this.balance < -1000){
        this.$confirm('运营豆余额不足，请充值后再试。');
        return false;
      }
      let content = this._buildCopyClipboardHeader(order);
      content += "\n";
      people.forEach(function (row) {
        content += row.name + " " + (row.cert_no || "") + " \n";
      });
      content += "\n联系人手机:" + (order.linker_mobile || "");
      let aux = document.createElement("textarea");
      aux.value = content;
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      this.$message({message: "复制成功!", type: "success"});
      this.$http.request('copyPeopleLog',{order_uuid:order.uuid,copy_content:content});
    },
    doShowDetails: function (uuid) {
      this.currUuid = uuid;
      this.showDetails = true;
    },
    chooseSupplier: function (id, supplier) {
      this.$http.request('editPeopleSupplier', {id, supplier}).then(res => {
        console.log(res)
      })
    },
    maskIdCard:function (idNumber,certType){
      if(certType !== '身份证'){
        return idNumber;
      }
      const start = idNumber.slice(0, 6);
      const end = idNumber.slice(15);
      const hiddenPart = "*******";
      return start + hiddenPart + end;
    },
    maskPhone:function (phone){
      const start = phone.slice(0, 3);
      const end = phone.slice(7);
      const hiddenPart = "****";
      return start + hiddenPart + end;
    },
    getProductList:function (){
      let _self = this;
      this.$http.request('productList', {type: this.$route.meta.goodsType}).then((res) => {
        _self.productList = res.data;
      });
    },
    confirmCancelIntentionRefund: function (item) {
      const _self = this;
      this.$confirm('确认取消该订单的退款申请？取消后订单将恢复为正常状态（用户端不再显示退款审核）。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _self.doCancelIntentionRefund(item.uuid);
      }).catch(() => {});
    },
    doCancelIntentionRefund: function (uuid) {
      this.$http.request('cancelIntentionRefund', {uuid: uuid}).then(res => {
        if (res.status === 'success') {
          this.$message({message: res.message, type: 'success'});
          this.getOrder('', false);
        }
      });
    },
    getIntentionRefundCountdown: function (intentionRefundInfo) {
      if (!intentionRefundInfo || !intentionRefundInfo.submit_at) {
        return '';
      }
      let deadlineMs;
      if (intentionRefundInfo.deadline_at) {
        deadlineMs = new Date((intentionRefundInfo.deadline_at || '').replace(/-/g, '/')).getTime();
      } else {
        const submitTime = new Date((intentionRefundInfo.submit_at || '').replace(/-/g, '/')).getTime();
        deadlineMs = submitTime + 15 * 3600 * 1000;
      }
      if (!deadlineMs) {
        return '处理中';
      }
      const leftSeconds = Math.floor((deadlineMs - this.nowTs) / 1000);
      if (leftSeconds <= 0) {
        return '已超时，平台介入';
      }
      const hour = Math.floor(leftSeconds / 3600).toString().padStart(2, '0');
      const minute = Math.floor((leftSeconds % 3600) / 60).toString().padStart(2, '0');
      const second = (leftSeconds % 60).toString().padStart(2, '0');
      return `剩余 ${hour}:${minute}:${second}`;
    },
    
    /**
     * 初始化订单提醒服务
     */
    initializeOrderReminder: function () {
      // 如果订单提醒已启用，则启动服务
      if (this.$store.getters.orderReminder.enabled) {
        OrderReminderService.startReminder();
      }
    },
    startCountdownTimer: function () {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.countdownTimer = setInterval(() => {
        this.nowTs = Date.now();
      }, 1000);
    }
  },
  created: function () {
    this.getAppOptions();
    this.getBalance();
    this.getProductList();
    this.getMeetingPointOptions();
    this.filter['goods_type'] = this.$route.meta.goodsType;
    if (this.$route.query.uuid) {
      this.filter.uuid = String(this.$route.query.uuid).trim();
    }
    this.getOrder();
    
    // 初始化订单提醒服务
    this.initializeOrderReminder();
    this.startCountdownTimer();
  },
  
  beforeDestroy: function () {
    // 组件销毁时清理订单提醒服务
    OrderReminderService.stopReminder();
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  },
  watch: {
    '$route': function () {
      this.filter['goods_type'] = this.$route.meta.goodsType;
      if (this.$route.query.uuid) {
        this.filter.uuid = String(this.$route.query.uuid).trim();
      }
      this.getProductList();
      this.getOrder();
    }
  }
}
</script>

<style scoped>

.order-filter-wrap {
  margin-bottom: 12px;
}

.order-filter-control {
  width: 100%;
}

.order-filter-form /deep/ .el-form-item {
  margin-bottom: 8px;
}

.table-card {
  width: 100%;
  font-size: 12px;
  margin-top: 30px;
}

.table-card .order-info {
  background: #f9f9f9;
  overflow: hidden;
  border: 1px solid #dcdcdc;
}

.table-card .order-info .order-item {
  float: left;
  width: 25%;
  padding: 5px 10px;
  box-sizing: border-box;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table tr:hover {
  background: #eee;
}

.table td {
  border: 1px solid #dcdcdc;
  padding: 10px;
}

.intention-refund-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.refund-audit-banner {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  color: #cf1322;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
}

.refund-audit-title {
  color: #cf1322;
}

.refund-audit-time {
  color: #fa541c;
}

.mp-detail {
  font-size: 12px;
  line-height: 1.6;
  color: #333;
}

.mp-detail-row {
  margin-bottom: 6px;
  word-break: break-all;
}

.mp-detail-row strong {
  color: #666;
  font-weight: 600;
}

.mp-detail-images {
  margin-top: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.mp-detail-thumb {
  width: 88px;
  height: 88px;
  border-radius: 4px;
  object-fit: cover;
}

.resolve-order-summary {
  margin-bottom: 12px;
  padding: 10px 12px;
  border: 1px solid #ebeef5;
  background: #f8f9fc;
  border-radius: 6px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 6px;
  grid-column-gap: 12px;
}

.resolve-order-summary__item {
  color: #606266;
  font-size: 13px;
}

.no-data {
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  margin-top: 30px;
}

.remark {
  cursor: pointer;
  padding: 3px 10px;
}

.remark:hover {
  box-shadow: 2px 2px 8px #888;
  border-radius: 5px;
}

.order-short-code {
  font-weight: 700;
  color: #d03030;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/order-list.vue